import { NUMBER_300, NUMBER_60 } from '~shared/constants';
import { InjectionToken } from '@angular/core';

export const CACHE_TIMER = NUMBER_300;
export const MINUTE_IN_SECONDS = NUMBER_60;
export const HOUR_IN_SECONDS = NUMBER_60 * NUMBER_60;

export const SSR_LOCALE_ID = new InjectionToken('SSR_LOCALE_ID');
export const DYSON_BRAND_SLUG = 'dyson';
